var baseStyleCloseButton = {
  fontSize: '1.125rem',
  w: '2.375rem',
  h: '1.375rem',
  ml: '0.625rem',
  mr: -3,
  borderRadius: '0',
  borderTopRightRadius: '0.25rem',
  borderBottomRightRadius: '0.25rem',
  color: 'blue.600',
  flexShrink: '0',
  overflow: 'hidden',
  _disabled: {
    opacity: 0.4
  },
  _hover: {
    bg: '#D4EEFF'
  },
  _focus: {
    boxShadow: "none",
    bg: '#1076BC',
    color: 'white'
  },
  _active: {
    bg: '#CEDEF0'
  }
};
var baseStyle = {
  container: {
    borderRadius: '0.25rem',
    bg: 'white',
    color: '#000',
    border: '1px solid',
    borderColor: 'blue.600',
    fontWeight: '400',
    h: 6,
    minH: 6,
    px: 3
  },
  closeButton: baseStyleCloseButton
};
export var Tag = {
  baseStyle
};